import React, { Component } from "react";
import moment from "moment";
import { Button, FormItem } from "carbon-components-react";
import StepCard from "../../StepCard";

import DatePicker from "../../DatePicker";

class PeriodCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInicioFormatada: props.data.dataInicioFormatada || "",
      dataFimFormatada: props.data.dataFimFormatada || "",
      salvouPeriodo: false
    };
  }

  componentWillMount = () => {
    const { data } = this.props;
    if (data && data.dataInicioFormatada && data.dataFimFormatada) {
      this.setState({ salvouPeriodo: true });
    }
  };

  renderDescription = () => {
    const { step, data } = this.props;
    if (data && data.dataInicioFormatada && data.dataFimFormatada) {
      return (
        <div className="font-size-13" style={{ color: "#36474f" }}>
          <strong>Período: </strong>
          {data.dataInicioFormatada}
          {" -"}

          {data.dataFimFormatada}
        </div>
      );
    }

    return step.description;
  };

  cancel = () => {
    // this.setState({ selectedValue: this.props.selectedValue });
    this.stepCardRef.toggleContent();
  };

  canSave = () => {
    const { clicked } = this.state;

    //  const { buttonIn } = this.props;
    if (clicked) {
      this.setState({ salvouPeriodo: true });
      this.stepCardRef.toggleContent();
    } else {
      return false;
    }
    return undefined;
  };

  save = async clicked => {
    const { dataInicioFormatada, dataFimFormatada } = this.state;
    const { saveStep } = this.props;
    await saveStep({
      DataInicio: dataInicioFormatada,
      DataFim: dataFimFormatada,
      salvouPeriodo: true,
      clicked
    });
    this.setState({ clicked });
    await this.canSave();
  };

  render() {
    const { step, buttonIn, data, isIstore } = this.props;
    const { dataInicioFormatada, dataFimFormatada, salvouPeriodo } = this.state;

    const dataInicial = data.dataInicio || dataInicioFormatada;
    const dataFinal = data.dataFim || dataFimFormatada;
    const today = moment();
    const disabledAdvanced =
      moment(dataInicial).isValid() && moment(dataFinal).isValid();

    return (
      <StepCard
        onRef={ref => {
          this.stepCardRef = ref;
        }}
        title={step.title}
        description={this.renderDescription()}
        isFinished={salvouPeriodo}
        disabled={isIstore}
      >
        <div className="bx--row mg-top-20">
          <div className=" bx--col-xs-12   bx--col-md-12 data-dm">
            <div className="bx--form-item--inline">
              <FormItem className="form-item-inline">
                <label className="bx--label">De:</label>
                <DatePicker 
                  id="dataInicioFormatada"
                  locale="pt-br"
                  date={
                    dataInicial && moment(dataInicial).isValid()
                      ? moment(dataInicial)
                      : ""
                  }
                  readOnly
                  onDateChange={date => {
                    this.setState(
                      {
                        dataInicioFormatada: date
                      },
                      async () => {
                        if (data) {
                          await this.save();
                        }
                      }
                    );
                  }}
                  isOutsideRange={day => day.isBefore(today)}
                />
              </FormItem>

              <FormItem className="form-item-inline">
                <label className="bx--label">Até:</label>
                <DatePicker
                  id="dataFimFormatada"
                  date={dataFinal ? moment(dataFinal) : ""}
                  locale="pt"
                  readOnly
                  onDateChange={date => {
                    this.setState(
                      {
                        dataFimFormatada: date
                      },
                      async () => {
                        if (data) {
                          await this.save();
                        }
                      }
                    );
                  }}
                  isOutsideRange={day => day.isBefore(today)}
                />
              </FormItem>
            </div>
          </div>
        </div>
        {buttonIn && (
          <div className="bx--row">
            <div className="bx--col-md-12">
              <br /> <br />
              <div className="v-md-margin mg-top-40">
                <Button
                  disabled={!disabledAdvanced}
                  onClick={() => this.save(true)}
                >
                  Avançar
                </Button>
                <Button
                  kind="ghost"
                  className="h-sm-margin"
                  onClick={this.cancel}
                >
                  Cancelar
                </Button>
              </div>
            </div>
          </div>
        )}
      </StepCard>
    );
  }
}

export default PeriodCampaign;



// WEBPACK FOOTER //
// ./src/components/trades/campaign/PeriodCampaign.js